import { DATE_FORMATS_FNS } from "components";
import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { formatDate } from "utils/dateHelperFunctions";

export const useSelectedDate = () =>
  useTypedQuery({ queryKey: AppointmentsQueryKeys.selectedDateToList, initialData: formatDate(new Date(), DATE_FORMATS_FNS.timeCarAppDate) }).data;

export const setSelectedDate = (selectedDate: Date) =>
  typedQueryClient.setQueryData(AppointmentsQueryKeys.selectedDateToList, formatDate(selectedDate, DATE_FORMATS_FNS.timeCarAppDate));
